import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface ErrorsInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: string;
    editTitle: string;
    editAlias: string;
    editDescription: string;
    // editParentId: string;
    deleteStatusModalVisible: boolean;
    deleteId?: string;
}

function getInitialState(): ErrorsInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteStatusModalVisible: false,
        editId: "",
        editTitle: "",
        editAlias: "",
        editDescription: "",
        // editParentId: "",
    };
}

export const ErrorsSlice = createSlice({
    name: "ErrorsSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),
        updateFields: (
          state: ErrorsInterface,
          action: PayloadAction<Partial<ErrorsInterface>>
        ) => {
            Object.assign(state, action.payload);
        },

    },

});

export const {updateFields, reset} = ErrorsSlice.actions;

export const ErrorsSelectors = {
    formVisible: (state: RootState) => state.errors.formVisible,
    formVariant: (state: RootState) => state.errors.formVariant,
    editId: (state: RootState) => state.errors.editId,
    editTitle: (state: RootState) => state.errors.editTitle,
    editAlias: (state: RootState) => state.errors.editAlias,
    editDescription: (state: RootState) => state.errors.editDescription,
    // editParentId: (state: RootState) => state.errors.editParentId,
    deleteModalVisible: (state: RootState) => state.errors.deleteStatusModalVisible,
    deleteId: (state: RootState) => state.errors.deleteId,
};

export const ErrorsReducer = ErrorsSlice.reducer;
